export enum EImportFilesStage {
  URLsRecieved,
  Uploading,
  Uploaded,
  ThumbnailImportStarted,
}
